import i18n from "@/core/plugins/vue-i18n";
import Common from "@/core/services/common";
import ApiService from "@/core/services/api.service";

const getWarehouseLocation = function (warehouse_id, idx_page = 0) {
	let default_val = idx_page == 1 ? Common.selection_all : [];
	return ApiService.post("warehouse-location/selection", { warehouse_id: warehouse_id })
		.then((response) => {
			if (response.status == 200) {
				let WarehouseLocation = default_val.concat(response.data.result);
				return WarehouseLocation;
			} else {
				return default_val;
			}
		})
		.catch(() => {
			return default_val;
		});
};

const getUom = function (idx_page = 0, data = { use_epo_inv_receive: 1 }) {
	let default_val = idx_page == 1 ? Common.selection_all : [];
	return ApiService.post("uom/selection", data)
		.then((response) => {
			if (response.status == 200) {
				let uom = default_val.concat(response.data.result);
				return uom;
			} else {
				return default_val;
			}
		})
		.catch(() => {
			return default_val;
		});
};
const getRefIdFormat = function (idx_page = 0) {
	let default_val = idx_page == 1 ? Common.selection_all : [];
	return ApiService.get("doc-num/ref-id-format")
		.then((response) => {
			if (response.status == 200) {
				let data = default_val.concat(response.data.result);
				return data;
			} else {
				return default_val;
			}
		})
		.catch(() => {
			return default_val;
		});
};


const getShipmentTerms = function (idx_page = 0) {
	let default_val = idx_page == 1 ? Common.selection_all : [];
	return ApiService.get("shipment-terms/selection")
		.then((response) => {
			if (response.status == 200) {
				let data = default_val.concat(response.data.result);
				return data;
			} else {
				return default_val;
			}
		})
		.catch(() => {
			return default_val;
		});
};
const getForwarder = function (idx_page = 0) {
	let default_val = idx_page == 1 ? Common.selection_all : [];
	return ApiService.get("forwarder/list")
		.then((response) => {
			if (response.status == 200) {
				let data = default_val.concat(response.data.result);
				return data;
			} else {
				return default_val;
			}
		})
		.catch(() => {
			return default_val;
		});
};

const getShipper = function (idx_page = 0) {
	let default_val = idx_page == 1 ? Common.selection_all : [];
	return ApiService.post("shipper/selection", {})
		.then((response) => {
			if (response.status == 200) {
				let data = default_val.concat(response.data.result);
				return data;
			} else {
				return default_val;
			}
		})
		.catch(() => {
			return default_val;
		});
};
const getShippingLine = function (idx_page = 0) {
	let default_val = idx_page == 1 ? Common.selection_all : [];
	return ApiService.post("shipping-line/selection", {})
		.then((response) => {
			if (response.status == 200) {
				let data = default_val.concat(response.data.result);
				return data;
			} else {
				return default_val;
			}
		})
		.catch(() => {
			return default_val;
		});
};
const getForwarderGroup = function (idx_page = 0) {
	let default_val = idx_page == 1 ? Common.selection_all : [];
	return ApiService.post("forwarder-group/selection", {})
		.then((response) => {
			if (response.status == 200) {
				let data = default_val.concat(response.data.result);
				return data;
			} else {
				return default_val;
			}
		})
		.catch(() => {
			return default_val;
		});
};
const getConsignee = function (idx_page = 0) {
	let default_val = idx_page == 1 ? Common.selection_all : [];
	return ApiService.post("consignee/selection", {})
		.then((response) => {
			if (response.status == 200) {
				let data = default_val.concat(response.data.result);
				return data;
			} else {
				return default_val;
			}
		})
		.catch(() => {
			return default_val;
		});
};

const getMsmSelection = function (agent_id, idx_page = 0) {
	let default_val = idx_page == 1 ? [] : [];
	return ApiService.post("main-salesman/selection", {
		agent_id: typeof agent_id == "object" ? null : agent_id,
		agent_ids: typeof agent_id == "object" ? agent_id : null
	})
		.then((response) => {
			if (response.data.code == 200) {
				let result = default_val.concat(response.data.result);
				return result;
			} else {
				return default_val;
			}
		})
		.catch(() => {
			return default_val;
		});
};

const getSmSelection = function (agent_id, msm_id = null, idx_page = 0) {
	let default_val = idx_page == 1 ? [] : [];
	return ApiService.post("salesman/selection", {
		agent_id: typeof agent_id == "object" ? null : agent_id,
		agent_ids: typeof agent_id == "object" ? agent_id : null,
		msm_id: typeof msm_id == "object" ? null : msm_id,
		msm_ids: typeof msm_id == "object" ? msm_id : null
	})
		.then((response) => {
			if (response.data.code == 200) {
				let result = default_val.concat(response.data.result);
				return result;
			} else {
				return default_val;
			}
		})
		.catch(() => {
			return default_val;
		});
};

const companyGroupSelection = async function (post_data = {}) {
	let response = await ApiService.post("company/group-selection", post_data);
	return response.data.code == 200 ? response.data.result : [];
};

const companySelection = async function (post_data = {}) {
	let response = await ApiService.post("company/selection", post_data);
	return response.data.code == 200 ? response.data.result : [];
};

export default {
	getWarehouseLocation,
	getUom,
	getRefIdFormat,
	getShipmentTerms,
	getForwarder,
	getShipper,
	getShippingLine,
	getForwarderGroup,
	getConsignee,
	getMsmSelection,
	getSmSelection,
	companyGroupSelection,
	companySelection
};
